import externalEventCodes from 'event-system/codes/external';

import {
  findIndexByPropertyValue,
  toMap
} from 'utilities/collection';

class StartupMembers {

  constructor(startup, supportingData = {}, modules) {

    this.startup = startup;
    this.membersLoaded = true;

    this.members = supportingData.members || [];

    this.serverInterface = modules.serverInterface;
    this.eventSystem = modules.eventSystem;

    this.searchMembers = this.searchMembers.bind(this);

  }

  tryRemoveStartupMembersMember(memberId) {

    const memberIndex = findIndexByPropertyValue(this.members, '_id', memberId);

    if (memberIndex === -1) {
      return;
    }

    this.members.splice(memberIndex, 1);

  }

  membersSorter(a, b) {

    const ownerId = this.startup.ownerId;
    const aFullName = a.fullName || a.email;
    const bFullName = b.fullName || b.email;

    if (a._id === ownerId) {
      return -1;
    } else if (b._id === ownerId) {
      return 1;
    }

    return aFullName.localeCompare(bFullName);

  }

  async loadMembers(forceLoad = false) {

    if (this.membersLoaded === true && forceLoad === false) {
      return this.members;
    }

    const projection = ['_id', 'username', 'firstName', 'lastName', 'fullName', 'profilePicture', 'email', 'emailIdentity', 'roleIds', 'openForMeetings'];

    this.members = await this.serverInterface.startup.getAllStartupMembers(projection);

    this.members = this.members.sort(this.membersSorter.bind(this));

    this.membersLoaded = true;

    return this.members;

  }

  async deleteMember(memberId) {

    const deleted = await this.serverInterface.startup.removeStartupMember(memberId);

    if (deleted === true) {
      this.tryRemoveStartupMembersMember(memberId);
    }

    return deleted;

  }

  async updateMemberById(memberId, emailIdentity) {

    const updated = await this.serverInterface.startup.updateStartupMemberEmailIdentity(memberId, emailIdentity);

    if (updated === true) {

      const index = findIndexByPropertyValue(this.members, '_id', memberId);

      this.members[index].emailIdentity = emailIdentity;

    }

    return updated;

  }

  getMembers() {

    return structuredClone(this.members);

  }

  getMemberMap() {

    return toMap(this.members, '_id');

  }

  isMemberExists(memberId) {

    const members = this.members;

    for (let member of members) {

      if (member._id === memberId) {
        return true;
      }

    }

    return false;

  }

  searchMembers(searchTerm) {

    const members = this.members;

    const matchingResults = [];

    for (let member of members) {

      if (member.fullName.localeCompare(searchTerm) === false) {
        continue;
      }

      const contact = {
        _id: member._id,
        startupUserId: member._id,
        name: member.fullName,
        value: member.username || member._id,
        profilePicture: member.profilePicture
      };

      matchingResults.push(contact);

    }

    return matchingResults;

  }

  handleStartupUserOpenForMeetingsChanged(data) {

    const startupUser = data.startupUser;

    const index = findIndexByPropertyValue(this.members, '_id', startupUser._id);

    if (index === -1) {
      return;
    }

    this.members[index].openForMeetings = startupUser.openForMeetings;

  }

  registerForEvents() {

    this.eventSystem.internal.on(externalEventCodes.STARTUP_USER_OPEN_FOR_MEETINGS_CHANGED, this.handleStartupUserOpenForMeetingsChanged.bind(this));

  }

  async initialize() {

    this.registerForEvents();

  }

}

export default StartupMembers;